<small class="debug"> {{me}} </small>
<div>
  <h2 class="form-signin-heading"></h2>
  <mat-form-field>
    <mat-label>{{'account.resetPasswordToEmail' | transloco}}</mat-label>
    <input [disabled]="m_disableInput" inputrestriction="login" matInput (keyup.enter)="passFocus()" #userName id="userName" spellcheck="false" type="text" name="m_user" [(ngModel)]="m_name" placeholder="" required autofocus>
  </mat-form-field>
  <br/>
  <br/>
  <button type="submit" (click)="onResetPassword()" class="sub" mat-stroked-button color="primary">
    {{'account.resetPassword' | transloco}}
    <mat-icon style="font-size: 1.3em; position: absolute; right: 10px">vpn_key</mat-icon>
  </button>
  <br/>
  <br/>
  @if (!hideBack) {
    <a color="warn" class="pull-left" (click)="$event.preventDefault(); setViewMode(m_viewMod.LOGIN)" href="#">
      <mat-icon style="position: relative; top: 6px">chevron_left</mat-icon>
    {{'account.back' | transloco}}</a>
  }
  <br/>
</div>
